import { useState } from "react";
import { serverFetch } from "@server";
import { Input, message, Modal } from "antd";

const CompanyToken = ({ token, visible, onClose }) => {
  const [editData, setEditData] = useState({ code: token?.code || "", active: token?.active ?? true });
  const [loading, setLoading] = useState(false);

  const handleSave = () => {
    setLoading(true);
    const method = token?.id ? "PUT" : "POST";
    const url = token?.id ? `token/${token.id}` : "token";
    
    serverFetch(url, { method, bodyData: editData })
      .then(() => { message.success(token?.id ? "Токен обновлен" : "Токен добавлен"); onClose(true); })
      .catch(e => { setLoading(false); message.error(e.userMessage || "Ошибка при сохранении"); });
  };

  return (
    <Modal title={token?.id ? "Редактирование токена" : "Добавление токена"} open={visible} onOk={handleSave} 
      onCancel={() => onClose(false)} okText="Сохранить" cancelText="Отмена" confirmLoading={loading}>
      <div style={{ marginTop: 16 }}>
        {token?.id && (
          <div style={{ marginBottom: 16 }}>
            <label>Код:</label>
            <Input value={editData.code} readOnly style={{ marginTop: 8 }} />
          </div>
        )}
        <div>
          <label>
            <input type="checkbox" checked={editData.active} onChange={e => setEditData({...editData, active: e.target.checked})} style={{ marginRight: 8 }} />
            Активен
          </label>
        </div>
      </div>
    </Modal>
  );
};

export default CompanyToken;

